module.exports = __webpack_public_path__ + "static/graphql-asia-logo-icon-73e36eeb70b829897694c0ccc4cdb1be.png";